let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("dWaws"), load("5JRy7")]).then(() => parcelRequire('lpr1L'));